module.exports = __webpack_public_path__ + "static/media/sad-instructor.201092a8.png";